import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Button, Checkbox, FormControlLabel, Grid, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
// import DateFnsUtils from "@date-io/date-fns";
// import esLocale from "date-fns/locale/es";
// import moment from 'moment';
import AutoCompleteDiagnostico from '../../../recetasDigitales/UI/AutoCompleteDiagnostico';
import { useFormNew } from '../../../../hooks/useFormNew';
import Title from './ResumenHCE/Title';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { HCE_PERMISOS } from '../../../../utils/permisos';
import { GenericModal } from '../../../atomic/organisms/GenericModal';
import BuscadorMedicamento from '../../../recetasDigitales/Ingreso/BuscadorMedicamento';
import { Clear } from '@material-ui/icons';
import { postMedicacionActiva, traerMedicacionActiva } from '../../../../actions/hce/hceActions';
import { MedicacionActivaItem } from './MedicacionActivaItem';

export const TabMedicacionIndicada = ({ hce }) => {


  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { medicacionActiva, disabled } = useSelector((state) => state.hce);
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const autoCompleteRef = useRef(null);
  const codigoMedicamentoRef = useRef(null);
  const [autoCompleteValue] = useState(null);

  let diagnosticoReceta = null;
  const [diagnostico, setDiagnostico] = useState(diagnosticoReceta);
  const [codigoMedicamento, setCodigoMedicamento] = useState(null);


  useEffect(() => {
    dispatch(traerMedicacionActiva(hce.idAfiliado, hce.idAfiliadoExterno));
  }, []);

  const initialValues = {
    idAfiliado: hce?.idAfiliado ? hce.idAfiliado : 0,
    idAfiliadoExterno: hce?.idAfiliadoExterno ? hce.idAfiliadoExterno : 0,
    idAgenda: hce.idAgenda,
    idDiagnostico: '',
    indicacion: '',
    idMedicamento: '',
    cantidad: '',
    dosis: '',
    posologia: '',
    tratamientoProlongado: 0,
    fechaFinalizacion: '',

  };

  const { formValues, handleInputChange, reset, setearValor } = useFormNew(initialValues);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postMedicacionActiva({ ...formValues }, setModal));
    setDiagnostico(null);
    setCodigoMedicamento(null);
    reset();
  };

  const changeDiagnosticoHandler = (value) => {
    setDiagnostico(value);
    setearValor("idDiagnostico", value.idProblema);

  };


  useEffect(() => {
    if (codigoMedicamento?.idMedicamento > 0)
      setearValor("idMedicamento", codigoMedicamento.idMedicamento);
  }, [codigoMedicamento]);

  console.log(medicacionActiva)


  return (
    <>
      <Title>
        Medicación Activa{' '}
        {validarSoloUnPermiso(
          permisosUser,
          HCE_PERMISOS.HCE,
        ) && (
            <>
              {!disabled &&
                <Button
                  disabled={disabled}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    setModal(true);
                  }}
                >
                  + Ingresar medicacion activa
                </Button>
              }
            </>
          )}
      </Title>
      {Array.isArray(medicacionActiva) && medicacionActiva?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '10%' }}>Diagnostico</TableCell>
              <TableCell style={{ width: '10%' }}>Medicamento</TableCell>
              <TableCell style={{ width: '10%' }}>Indicacion</TableCell>
              <TableCell style={{ width: '10%' }}>Cantidad</TableCell>
              <TableCell style={{ width: '10%' }}>Dosis</TableCell>
              <TableCell style={{ width: '10%' }}>Indicación</TableCell>
              <TableCell style={{ width: '10%' }}>Posología</TableCell>
              <TableCell style={{ width: '10%' }}>Tratamiento Prolongado</TableCell>
              <TableCell style={{ width: '20%' }}>Fecha Finalizacion</TableCell>
              <TableCell style={{ width: '20%' }}>Usuario Carga</TableCell>
              <TableCell style={{ width: '20%' }}>Especialidad</TableCell>
              <TableCell style={{ width: '20%' }}>Finalizar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {medicacionActiva.map((medicacion, index) => {
              return (
                <MedicacionActivaItem
                  key={medicacion?.id.toString()}
                  medicacion={medicacion}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
          No hay medicamentos activos Registrados
        </Typography>
      )}
      {modal && (
        <GenericModal
          open={modal}
          closeModal={() => {
            setModal(false);
          }}
          title={'Agregar medicacion activa'}
          gridStyle={{ textAlign: 'center', padding: '1em' }}
          maxWidth="md"
        >
          <ValidatorForm onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {!diagnostico && (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <AutoCompleteDiagnostico
                    ref={autoCompleteRef}
                    autoCompleteValue={autoCompleteValue}
                    label="Diagnóstico"
                    onChangeHandler={changeDiagnosticoHandler}
                  />
                </Grid>
              )}
              {!!diagnostico && (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextValidator
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Diagnostico"
                    autoComplete="off"
                    name="indicacion"
                    value={diagnostico.problema}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={() => { setDiagnostico(null) }} edge="end" aria-label="clear diagnostico">
                          <Clear />
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Indicación"
                  autoComplete="off"
                  name="indicacion"
                  value={formValues.indicacion}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["Requerido"]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <BuscadorMedicamento
                  ref={codigoMedicamentoRef}
                  cod={codigoMedicamento}
                  label="Medicamento (Presentación | Laboratorio | Nombre | Drogas)"
                  fieldsDisabled={false}
                  autorizacion={true}
                  setCod={(val) => setCodigoMedicamento(val)}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Cantidad"
                  autoComplete="off"
                  name="cantidad"
                  type="number"
                  value={formValues.cantidad}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["Requerido"]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Dosis"
                  autoComplete="off"
                  name="dosis"
                  value={formValues.dosis}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["Requerido"]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Posología"
                  autoComplete="off"
                  name="posologia"
                  value={formValues.posologia}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["Requerido"]}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={3} md={3} lg={3}>
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    fullWidth
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    margin="normal"
                    id="dialogFecFin"
                    label="Fecha Finalizacion"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    value={
                      moment(formValues.fechaFinalizacion).isValid()
                        ? moment(formValues.fechaFinalizacion)
                        : null
                    }
                    onChange={(date) => {
                      setearValor("fechaFinalizacion", date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid> */}
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formValues.tratamientoProlongado}
                      onChange={(e) => setearValor("tratamientoProlongado", e.target.checked)}
                      name="tratamientoProlongado"
                      color="primary"

                    />
                  }
                  label="Tratamiento Prolongado"
                  labelPlacement="end"
                  style={{ fontWeight: 'bold', marginTop: "20px" }} // Ajusta el estilo según lo desees
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                styles={{
                  display: 'flex',
                }}
              >
                <Button
                  variant="outlined"
                  style={{ marginRight: '1rem' }}
                  onClick={() => { setModal(false); setCodigoMedicamento(null); setDiagnostico(null); }}
                >
                  Cancelar
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </ValidatorForm>
        </GenericModal>
      )}
    </>
  )
}
